import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Tabs, Tab, Divider, colors } from '@mui/material';

import { Page, Header } from 'components';
import {
	General,
	Subscription,
	Notifications,
	Security,
} from './components';

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: '100%',
		margin: '0 auto',
		padding: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	divider: {
		backgroundColor: colors.grey[300],
	},
	content: {
		marginTop: theme.spacing(3),
	},
}));

const Settings = (props) => {
	const classes = useStyles();
	const [tab, setTab] = useState('general');

	const handleTabsChange = (event, value) => {
		setTab(value);
	};

	const tabs = [
		{ value: 'general', label: 'General' },
		// { value: 'subscription', label: 'Subscription' },
		// { value: 'notifications', label: 'Notifications' },
		{ value: 'security', label: 'Security' },
	];

	if (!tab) {
		return <Redirect to="/home" />;
	}

	if (!tabs.find((t) => t.value === tab)) {
		return <Redirect to="/errors/error-404" />;
	}

	return (
		<Page className={classes.root} title="Settings">
			<Header module="Settings" view="Change account information" />
			<Tabs
				className={classes.tabs}
				onChange={handleTabsChange}
				scrollButtons="auto"
				value={tab}
				variant="scrollable"
			>
				{tabs.map((item) => (
					<Tab key={item.value} label={item.label} value={item.value} />
				))}
			</Tabs>
			<Divider className={classes.divider} />
			<div className={classes.content}>
				{tab === 'general' && <General />}
				{/* {tab === 'subscription' && <Subscription />}
				{tab === 'notifications' && <Notifications />} */}
				{tab === 'security' && <Security />}
			</div>
		</Page>
	);
};

Settings.propTypes = {
};

export default Settings;
